var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobsSearchIconLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.37253 13.6867H6.48681C4.22197 13.6867 3.08986 13.6867 2.38608 12.9697C1.68231 12.2527 1.68231 11.0991 1.68231 8.79064C1.68231 6.48283 1.68231 5.32862 2.38608 4.61157C3.08986 3.89453 4.22197 3.89453 6.48681 3.89453H8.88937C11.1542 3.89453 12.287 3.89453 12.9907 4.61157C13.5321 5.1631 13.6566 5.97364 13.6857 7.36919",
    stroke: "#6860EE",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0647 13.0688L14.3174 14.3178M13.7192 11.4913C13.7241 11.1956 13.6702 10.9018 13.5605 10.6272C13.4507 10.3525 13.2874 10.1024 13.0801 9.89153C12.8727 9.68064 12.6254 9.51314 12.3526 9.39881C12.0798 9.28447 11.787 9.22559 11.4913 9.22559C11.1955 9.22559 10.9027 9.28447 10.6299 9.39881C10.3571 9.51314 10.1099 9.68064 9.90248 9.89153C9.69511 10.1024 9.5318 10.3525 9.42207 10.6272C9.31235 10.9018 9.2584 11.1956 9.26338 11.4913C9.27322 12.0757 9.51227 12.6328 9.92901 13.0426C10.3457 13.4524 10.9068 13.682 11.4913 13.682C12.0757 13.682 12.6368 13.4524 13.0535 13.0426C13.4703 12.6328 13.7093 12.0757 13.7192 11.4913Z",
    stroke: "#6860EE",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5269 3.89376L10.4637 3.69792C10.151 2.72501 9.99495 2.23856 9.62284 1.96059C9.25011 1.68262 8.75607 1.68262 7.76611 1.68262H7.59996C6.61126 1.68262 6.1166 1.68262 5.7445 1.96059C5.37176 2.23856 5.21572 2.72501 4.903 3.69792L4.84109 3.89376",
    stroke: "#6860EE",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobsSearchIconLight);
export default __webpack_public_path__ + "static/media/Jobs Search Icon Light.f58b60e4f8ddc3f561eac8de2d67c0bf.svg";
export { ForwardRef as ReactComponent };